module.exports = __webpack_public_path__ + "img/title2.90772969.png";